<section class="card">
    <div class="card-body">
        <form class="cat__app__profile__container card-body py-0 px-0 px-sm-4" #f="ngForm">
            <div class="row">
                <div class="col-lg-12">
                    <h4 class="text-black"><strong>Insurance & Health information</strong></h4>
                    <div>
                        <div class="d-flex flex-column">
                            <label class="form-control-label">Insurance Company</label>
                            <input type="text"
                                   name="insurance-company"
                                   [(ngModel)]="model.insuranceCompany"
                                   class="form-control mb-2"
                                   maxlength="60">
                        </div>
                    </div>
                    <div>
                        <div class="d-flex flex-column">
                            <label class="form-control-label">Current Medical Conditions</label>
                            <textarea name="insurance-current-medical-conditions"
                                      [(ngModel)]="model.currentMedicalConditions"
                                      class="form-control insurance-textarea mb-2"
                                      maxlength="255"></textarea>
                        </div>
                    </div>
                    <div>
                        <div class="d-flex flex-column">
                            <label class="form-control-label">Current Medications</label>
                            <textarea name="insurance-current-medications"
                                      [(ngModel)]="model.currentMedications"
                                      class="form-control insurance-textarea mb-2"
                                      maxlength="255"></textarea>
                        </div>
                    </div>
                    <div>
                        <div class="d-flex flex-column">
                            <label class="form-control-label">Allergies</label>
                            <input type="text"
                                   name="insurance-allergies"
                                   [(ngModel)]="model.allergies"
                                   class="form-control mb-2"
                                   maxlength="255">
                        </div>
                    </div>
                </div>
                <div class="col-12 mt-3">
                    <button type="button"
                            class="btn btn-primary mr-2"
                            (click)="save()">Save</button>
                    <button type="button"
                            class="btn btn-outline-primary"
                            (click)="cancel()">Cancel</button>
                </div>
            </div>
        </form>
    </div>
</section>
